// extracted by mini-css-extract-plugin
export default {"dealItem":"DealItemsMaybe_dealItem__S5Nbn"};